import React, { useContext } from 'react';
import Card from 'react-bootstrap/Card';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { ICONS } from '../../img/icons';
import Icon from '../../img/Icon';
import { postContentWithAction } from '../../apiConnect';
import AppContext from '../../AppContext';

// This is a workaround to use the useTranslation hook in a class component
function ErrorWithHook(Component) {
    return function WrappedComponent(props) {
        const { t } = useTranslation();
        return <Component {...props} t={t} />;
    };
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        var errorObject = {
            message: error + "\n" + errorInfo?.componentStack,
            location: this.props.history?.location?.pathname ?? "unknown"
        }
        postContentWithAction(this.props.auth.getAccessToken(), "farm", "log-error", { ...errorObject }).catch(c => console.log(c));
        console.log(error + "\n" + errorInfo?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    <Container className="error-container">
                        <Card>
                            <Card.Body>
                                <Card.Title>
                                    <h3 className="error-page-text">{this.props.t('ErrorPageHeader')}</h3>
                                </Card.Title>
                                <Card.Text>
                                    <p className="error-page-text">
                                        {this.props.t('ErrorPageText')}
                                    </p>
                                    
                                    <button
                                        key={'return'}
                                        onClick={() => {
                                            console.log(
                                                'redirecting to home page'
                                            );
                                            this.props.history.push('/');
                                            window.location.reload();
                                        }}
                                        className={"error-redirect"}>
                                        <div className="text-dark button-div error-redirect">
                                            <Icon icon={ICONS.HOME} color='#1242a3' size='30' />
                                            {this.props.t('Button_RedirectToHome')}
                                        </div>
                                    </button>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Container>
                </>
            );
        }

        return this.props.children;
    }
}

export default ErrorWithHook(ErrorBoundary);